module.exports = __webpack_public_path__ + "./fonts/b303338697d86608c6e4a209ad8a153e.woff2";